"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var addedToDownPaymentLabel = 'Added to your down payment';
var addedToMonthlyPaymentsLabel = 'Added to monthly payments';
var appliedToDownPaymentLabel = 'Applied to your down payment';
var flexibilityToPayOffHeader = 'Flexibility to help payoff your loan balance.';
var incentivePurchasePriceSavingsLabel = 'Purchase price savings';
var learnMoreCta = 'Learn More';
var loanBalanceLabel = 'Loan balance';
var modalTitle = 'Trade In Details';
var rolloverText = 'Instead of paying the remaining balance of your loan out of pocket, we can help add up to $2,500 of your existing balance to the loan for your next car. This works a lot like refinancing. Get pre-qualified to see personalized financing terms while you shop.';
var rolloverTextWithDownPayment = 'Instead of paying the remaining balance of your loan out of pocket, we can help add up to $2,500 of your existing balance to the loan for your next car. The rest will be added to your down payment. This works a lot like refinancing. Get pre-qualified to see personalized financing terms while you shop.';
var salesTaxSavingsAmountText = 'Sales tax savings (estimate)';
var saveInSalesTaxHeader = function (salesTaxSavingsAmountValue, taxState) {
    return "Save ".concat(salesTaxSavingsAmountValue, " in ").concat(taxState, " sales tax");
};
var applyIncentiveHeader = function (incentive) {
    return "Get ".concat(incentive, " off the price of any Carvana car");
};
var saveMoreTag = 'Sales Tax Savings';
var sellOrTradeFooter = 'Sell or trade, we’ll be ready when you are. Save your offer to shop our 20,000 Carvana Certified vehicles with your trade-in applied.';
var tradeInSavingsTag = 'Trade-in Savings';
var tradeInTaxSavingsDescription = function (state) {
    return "When you trade in, it reduces the ".concat(state, " sales tax you pay. There\u2019s no delay or complicated paperwork to fill out - it\u2019s instant and automatic. You get a lower total purchase price and lower monthly payments.");
};
var incentiveDescription = 'Trade in your vehicle for more savings, simple online checkout, and one appointment to swap your old car for your new one.';
var yourTradeInDetailsTitle = 'Your trade in details';
var applyDefaultCardTitle = function (amount) {
    return "Apply ".concat(amount, " towards the down payment of your new vehicle");
};
var defaultCardTradeInSavingsLabel = 'Total trade in savings';
var applyDefaultCardDescription = 'Reduce your monthly payments by applying your total trade in value towards your new vehicle.';
exports.default = {
    addedToDownPaymentLabel: addedToDownPaymentLabel,
    addedToMonthlyPaymentsLabel: addedToMonthlyPaymentsLabel,
    appliedToDownPaymentLabel: appliedToDownPaymentLabel,
    applyDefaultCardDescription: applyDefaultCardDescription,
    applyDefaultCardTitle: applyDefaultCardTitle,
    applyIncentiveHeader: applyIncentiveHeader,
    defaultCardTradeInSavingsLabel: defaultCardTradeInSavingsLabel,
    flexibilityToPayOffHeader: flexibilityToPayOffHeader,
    incentiveDescription: incentiveDescription,
    incentivePurchasePriceSavingsLabel: incentivePurchasePriceSavingsLabel,
    learnMoreCta: learnMoreCta,
    loanBalanceLabel: loanBalanceLabel,
    modalTitle: modalTitle,
    rolloverText: rolloverText,
    rolloverTextWithDownPayment: rolloverTextWithDownPayment,
    salesTaxSavingsAmountText: salesTaxSavingsAmountText,
    saveInSalesTaxHeader: saveInSalesTaxHeader,
    saveMoreTag: saveMoreTag,
    sellOrTradeFooter: sellOrTradeFooter,
    tradeInSavingsTag: tradeInSavingsTag,
    tradeInTaxSavingsDescription: tradeInTaxSavingsDescription,
    yourTradeInDetailsTitle: yourTradeInDetailsTitle
};
